import { Toast } from 'antd-mobile'
import forge from 'node-forge';
import Cookie from 'js-cookie';
import { apiHomeData, apiNewsClassify, apiNewsList, getStudentVipInfo } from '@api'

import initWeixinShare from '@utils/share'
import tools from '@utils/tools'


export default {
    namespace: 'modal',
    state: {
        userInfo: {
            
        },
        vipInfo: {
            end_time: 0,//VIP到期时间
            is_stuVip: 0,//是否为VIP
        },
        isLogin: false,
        entryList: [],
        homeData: {
            bannerList: [],
            itemList:[],
            liveCourseList: [],
            videoCourseList: [],
            newsList: [],
            teacherList: [],
            leaveMsgList: [],
            logo: ''
        },
        //question
        classifyList: [],
        courseId: Cookie.get('courseId') || '',
        questionTitle: '',//题库头部标题
        questionChapterList: [],//题库章节列表
        refreshFlag: false,
        answerSheet: [],
        currentPreface: 0,
        course_type: 0,
        main_id: '',
        sub_id: '',
        news_tabs_id: '',
        news_category_list: [],
        wx_open_id: Cookie.get('userOpenId') || '',
        openid: Cookie.get('openid') || '',
    },
    reducers: {
        querySuccess(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
        LOAD_ANSWERSHEET(state, { answerSheet }) {
            answerSheet.question_num = answerSheet.indexList.length
            return {
                ...state,
                currentPreface: 0,
                answerSheet
            }
        },
        TOGGLE_FOLD(state, { id }) {
            console.log(state.questionChapterList, '<--------')
            findAndToggleFolder(state.questionChapterList, id);
            return {
                ...state,
                refreshFlag: !state.refreshFlag,
            }
        },
        LOAD_QUESTION(state, { qs, qtype }) {
            let answerSheet = state.answerSheet;
            for (let i = 0; i < qs.length; i++) {
                for (let j = 0; j < answerSheet.indexList.length; j++) {
                    if (qs[i].question_id === answerSheet.indexList[j].question_id) {
                        answerSheet.indexList[j].question = qs[i];
                        answerSheet.indexList[j].question.my_answer = [];
                        if (answerSheet.indexList[j].question_id === answerSheet.current_question_id) {
                            state.currentPreface = j + 1;
                        }
                        if (!answerSheet.is_new) {
                            if (answerSheet.type === 'normal' || answerSheet.type === 'daily' || answerSheet.type === 'wrong' || answerSheet.type === 'favorite') {
                                if (answerSheet.indexList[j].is_right != -1) {
                                    answerSheet.indexList[j].question.my_answer = answerSheet.indexList[j].question.last_answer.split(',');
                                    answerSheet.indexList[j].question.isChecked = true;
                                    answerSheet.indexList[j].question.isAnswered = true;
                                }
                            } else {
                                if (answerSheet.indexList[j].is_right != -1) {
                                    answerSheet.indexList[j].question.my_answer = answerSheet.indexList[j].question.last_answer.split(',');
                                    answerSheet.indexList[j].question.isAnswered = true;
                                }
                            }
                        }
                    }
                }
            }
            return {
                ...state,
                answerSheet: answerSheet,
            }
        },
        CHOOSE_OPTION(state, { id, mark }) {
            let answerSheet = state.answerSheet;
            let option = mark;
            for (let i = 0; i < state.answerSheet.indexList.length; i++) {
                if (answerSheet.indexList[i].question_id === id) {
                    if (answerSheet.indexList[i].question.qtype === 1) {//单选
                        answerSheet.indexList[i].question.my_answer[0] = option;
                        answerSheet.indexList[i].question.isAnswered = true
                        let myAnswer = answerSheet.indexList[i].question.my_answer;
                        let answers = answerSheet.indexList[i].question.options.answers;
                        if (myAnswer.slice(0, 1) == answers) {
                            answerSheet.indexList[i].is_right = 1
                        } else {
                            answerSheet.indexList[i].is_right = 0
                        }
                        if (answerSheet.type === 'normal' || answerSheet.type === 'daily' || answerSheet.type === 'wrong' || answerSheet.type === 'favorite') {
                            answerSheet.indexList[i].question.isChecked = true
                        } else {
                            if (state.currentPreface < answerSheet.question_num) {
                                state.currentPreface = state.currentPreface + 1;
                            }
                        }
                    } else {
                        let idx = answerSheet.indexList[i].question.my_answer.indexOf(option);
                        if (idx !== -1) {
                            answerSheet.indexList[i].question.my_answer.splice(idx, 1)
                        } else {
                            answerSheet.indexList[i].question.my_answer.push(option)
                        }
                    }
                }
            }
            return {
                ...state,
                answerSheet,
                refreshFlag: !state.refreshFlag//触发刷新
            }
        },
        //下一题
        INCREASE_PREFACE(state) {
            return {
                ...state,
                currentPreface: state.currentPreface + 1,
            }
        },
        //上一题
        REDUCE_PREFACE(state) {
            return {
                ...state,
                currentPreface: state.currentPreface - 1,
            }
        },
        //收藏题目
        COLLECT_QUESTION(state, { qid, isCollect }) {
            let answerSheet = state.answerSheet
            //遍历题目，找出收藏项
            for (let i = 0; i < answerSheet.indexList.length; i++) {
                if (answerSheet.indexList[i].question && answerSheet.indexList[i].question.question_id === qid) {
                    answerSheet.indexList[i].question.is_collect = isCollect;
                }
            }
            return {
                ...state,
                refreshFlag: !state.refreshFlag
            }
        },
        //记录时间
        RECORD_TIME(state, { time }) {
            state.answerSheet.last_duration = time;
            return {
                ...state,
                refreshFlag: !state.refreshFlag
            }
        },
        CHOOSE_PREFACE(state, { choosePreface }) {
            return {
                ...state,
                currentPreface: choosePreface,
            }
        },
        CLEARUP_ANSWERSHEET(state) {
            return {
                ...state,
                answerSheet: {}
            }
        },
        ANALYSIS_QUESTION(state) {
            for (let i = 0; i < state.answerSheet.indexList.length; i++) {
                state.answerSheet.last_duration = 0;
                state.answerSheet.indexList[i].question.isChecked = true;
            }
            state.answerSheet.redo = false;
            state.answerSheet.analysis = true;
            return {
                ...state,
                currentPreface: 1,
                refreshFlag: !state.refreshFlag
            }
        },
        REDO_QUESTION(state) {
            for (let i = 0; i < state.answerSheet.indexList.length; i++) {
                state.answerSheet.indexList[i].is_right = -1;
                state.answerSheet.indexList[i].question.my_answer = [];
                state.answerSheet.indexList[i].question.isChecked = false;
                state.answerSheet.indexList[i].question.isAnswered = false;
            }
            state.answerSheet.redo = true;
            state.answerSheet.analysis = false;
            return {
                ...state,
                currentPreface: 1,
                refreshFlag: !state.refreshFlag
            }
        },
        SAVE_OPENID(state, { openid }) {
            return {
                ...state,
                openid: openid
            }
        }

    },

    effects: dispatch => ({
        //登陆接口
        async checkLogin({ user_num, password, cb }, state) {
            let res = await global.http.post('loginAndRegister/checkLogin', {
                mobile: user_num,
                password: password,
                merchant_id: global.constants.merchant_id,
            });
            if (res.errcode === 0) {
                Cookie.set('authorization', res.result.token, { path: '/' })
                let userInfo = {};
                userInfo.id = res.result.id
                userInfo.user_name = res.result.user_name;
                userInfo.mobile = res.result.mobile;
                userInfo.head_img = res.result.head_img;
                Cookie.set('userInfo', userInfo, { path: '/' })
                dispatch.modal.querySuccess({ payload: { userInfo: userInfo, isLogin: true } })
                cb();
            } else {
                Toast.show(res.errmsg, 1)
            }
        },
        async verifyLogin({cb}, state) {
            let authorization = Cookie.get('authorization') //取token
            if (authorization) {
                let res = await global.http.post('loginAndRegister/testToken', {});
                //如果token存在，token
                if (res.errcode === 0) {
                    // Toast.info('您当前为已登录状态',1);
                    let userInfo = Cookie.get('userInfo');
                    dispatch.modal.querySuccess({ payload: { userInfo: JSON.parse(userInfo), isLogin: true } })
                } else {
                    Toast.info(res.errmsg, 1);
                    Cookie.remove('authorization');
                    dispatch.modal.querySuccess({ payload: { userInfo: {}, isLogin: false } })
                }
            } else {
                dispatch.modal.querySuccess({ payload: { userInfo: {}, isLogin: false } })
            }
            cb && cb()
        },
        async loginOut({ user_num, password, cb }, state) {
            Cookie.set('authorization', '', { path: '/' })
            dispatch.modal.querySuccess({ payload: { userInfo: {}, vipInfo: {}, isLogin: false } })
        },
        async getStudentVipInfo({ }, state) {
            let res = await getStudentVipInfo();
            if (res.errcode == 0) {
                dispatch.modal.querySuccess({
                    payload: {
                        vipInfo: {
                            ...state.modal.vipInfo,
                            ...res.result.userInfo,
                        }
                    }
                })
            }else{
                dispatch.modal.querySuccess({
                    payload: {
                        vipInfo: {}
                    }
                })
            }
            // else {
            //     Toast.info(res.errmsg, 1)
            // }
        },
        //获取首页数据
        async getHomeDetail({ url }) {
            Toast.loading('加载中', 0)
            let res = await apiHomeData()
            if (res.errcode == 0) {
                let homeData = res.result;
                dispatch.modal.querySuccess({ payload: { homeData } })
                Toast.hide()
                //分享参数
                let params = {
                    title: '吉林省中小学生必背古诗词',
                    desc: '中小学生必背古诗词',
                    link: url.split('/home')[0]+'/home',
                    imgUrl: homeData.logo.logo,
                    success: function () {
                        console.log("分享成功!");
                    }
                }
                console.log(params, '<-----params')
                if (!tools.isWeiXin()) {
                    return;
                }
                initWeixinShare(params)
            } else {
                Toast.info(res.errmsg,1)
            }
            
        },
        //获取题库分类
        async getClassifyList() {
            let res = await global.http.post('chapter/queryChapter', {
                merchant_id: global.merchant_id,
                custom_id: global.custom_id,
                app_device: global.app_device,
                app_version: global.app_version
            })
            if (res.errcode === 0) {
                let classifyList = res.result
                await dispatch.modal.querySuccess({ payload: { classifyList } })
            } else {
                Toast.info(res.errmsg)
            }
        },
        //选择题库分类
        chooseClassify(id) {
            Cookie.set('courseId', id, { path: '/' })
            dispatch.modal.querySuccess({ payload: { courseId: id } })
            this.getQuestionHeader(id)
            this.loadChapterList(id)
        },
        //题库header文本
        async getQuestionHeader(id) {
            let res = await global.http.post('home/queryHomePageTitle', { course_id: id });
            if (res.errcode === 0) {
                dispatch.modal.querySuccess({ payload: { questionTitle: res.result.title } })
            } else {
                Toast.info(res.errmsg)
            }
        },
        async loadChapterList(id) {
            let res = await global.http.post('chapter/queryTree', { course_id: id });
            if (res.errcode === 0) {
                dispatch.modal.querySuccess({ payload: { questionChapterList: res.result } })
            } else {
                Toast.info('请选择分类', 1)
            }
            // //验证每日一练是否有题
            // let dailyRes = await http.post('dailyPractice/list', {
            //       course_id: courseId
            // });
            // if (dailyRes.errcode === 0) {
            //       if (dailyRes.result) {
            //             this.setState({ hasDaily: true })
            //       }
            // }
        },
        toggleFold({ id }, state) {
            dispatch.modal.TOGGLE_FOLD({ id })
        },
        //加载题目列表
        async loadSheetList({ loadType, id, type }, state) {
            let res = await global.http.post('question/initPaper', {
                paper_id: id,
                qtype: type
            });
            if (res.errcode === 0) {
                await dispatch.modal.LOAD_ANSWERSHEET({ answerSheet: res.result })
                // if (!res.result.is_new) {
                //       Toast.info('继续上次答题', 0.5)
                // }
                let popQuestionList = res.result.indexList;
                // eslint-disable-next-line no-unused-vars
                let count = 0;//缓冲计数
                let ids = [];//查询的id
                // eslint-disable-next-line no-unused-vars
                let isFound = false;
                for (let i = 0; i < popQuestionList.length; i++) {
                    // if(popQuestionList[i].question_id===res.result.current_question_id){
                    //     isFound=true;
                    // }
                    // if(isFound && count<20){
                    //     count++
                    ids.push(popQuestionList[i].question_id)
                    // }
                }
                this.loadQuestion({ ids, id: res.result.record_id, qtype: type, loadType });
            } else {
                Toast.info(res.errmsg)
            }
        },
        //加载每日一练
        async loadDailyList({ id }) {
            let res = await global.http.post('dailyPractice/list', {
                course_id: id
            });
            if (res.errcode === 0) {
                dispatch.modal.LOAD_ANSWERSHEET({ answerSheet: res.result })
                let popQuestionList = res.result.indexList;
                // eslint-disable-next-line no-unused-vars
                let count = 0;//缓冲计数
                let ids = [];//查询的id
                // eslint-disable-next-line no-unused-vars
                let isFound = false;
                console.log(res, '<-----daily')
                for (let i = 0; i < popQuestionList.length; i++) {
                    ids.push(popQuestionList[i].question_id)
                }
                this.loadQuestion({ ids, id: 0, qtype: 0, loadType: 'daily' });
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        // 监听题目加载
        async loadQuestion({ ids, id, qtype, loadType }, state) {
            let res = await global.http.post('question/getQestionDetailByIds', {
                question_ids: ids,
                record_id: id
            });
            if (res.errcode === 0) {
                //塞到answerSheet
                let qs = res.result;
                let answerSheet = state.modal.answerSheet;
                answerSheet.type = loadType;
                dispatch.modal.LOAD_ANSWERSHEET({ answerSheet })
                dispatch.modal.LOAD_QUESTION({ qs, qtype })
            } else {
                Toast.info(res.errmsg)
            }
        },
        //答题选择题目
        async chooseOption({ id, mark }, state) {
            dispatch.modal.CHOOSE_OPTION({ id, mark })
        },
        //下一题
        nextQuestion() {
            dispatch.modal.INCREASE_PREFACE()
        },
        //上一题
        preQuestion() {
            dispatch.modal.REDUCE_PREFACE()
        },
        //收藏题目
        async collectQuestion({ qid, isCollect }) {
            let res = {}, res2 = {}
            if (isCollect === 0) {
                res = await global.http.post('student/collect', {
                    question_id: qid
                });
                console.log(res, '<----')
                if (res.errcode === 0) {
                    dispatch.modal.COLLECT_QUESTION({ qid, isCollect: 1 })
                } else {
                    Toast.info(res.errmsg, 0.5)
                }
            } else {
                res2 = await global.http.post('student/uncollect', {
                    question_id: qid
                });
                console.log(res2, '<----')
                if (res2.errcode === 0) {
                    dispatch.modal.COLLECT_QUESTION({ qid, isCollect: 0 })
                } else {
                    Toast.info(res2.errmsg, 0.5)
                }
            }
        },
        //记录答题时间
        recordTime({ time }) {
            dispatch.modal.RECORD_TIME({ time })
        },
        //答题卡选中项
        chooseQuestion({ idx, cb }) {
            dispatch.modal.CHOOSE_PREFACE({ choosePreface: idx })
            cb();
        },
        //提交答题记录
        async submitRecord({ answerSheet, status, cb }) {
            let questionRecords = []
            for (let i = 0; i < answerSheet.indexList.length; i++) {
                let item = answerSheet.indexList[i];
                if (item.is_right !== '-1') {
                    let obj = {};
                    obj.question_id = item.question_id;
                    obj.last_duration = answerSheet.last_duration;
                    obj.is_right = item.is_right;
                    obj.my_answer = item.question.my_answer.toString();
                    questionRecords.push(obj)
                }
            }
            let res = await global.http.post('question/submitQuestionRecords', {
                paper_id: answerSheet.paper_id,
                record_id: answerSheet.record_id,
                question_records: questionRecords
            });
            if (res.errcode === 0) {
                cb()
            } else {
                Toast.info(res.errmsg, 1)
            }
            if (status === 'done') {
                //提交答卷 重置本次答题
                let res2 = await global.http.post('question/submitExam', {
                    paper_id: answerSheet.paper_id,
                    record_id: answerSheet.record_id,
                });
                if (res2.errcode === 0) {
                    Toast.info('提交答卷成功', 1)
                } else {
                    Toast.info(res.errmsg, 1)
                }
            }
        },
        //清空answerSheet
        clearUpAnswerSheet() {
            dispatch.modal.CLEARUP_ANSWERSHEET()
        },
        //全题解析
        analysisQuestion(cb) {
            dispatch.modal.ANALYSIS_QUESTION()
            cb()
        },
        //试题重做
        redoQuestion(cb) {
            dispatch.modal.REDO_QUESTION()
            cb()
        },
        //错题重做
        async loadWrongList({ id, pid }) {
            let res = await global.http.post('home/queryErrorQuestionInitList', {
                course_id: id,
                paper_id: pid
            });
            if (res.errcode === 0) {
                dispatch.modal.LOAD_ANSWERSHEET({ answerSheet: res.result })
                let popQuestionList = res.result.indexList;
                // eslint-disable-next-line no-unused-vars
                let count = 0;//缓冲计数
                let ids = [];//查询的id
                // eslint-disable-next-line no-unused-vars
                let isFound = false;
                for (let i = 0; i < popQuestionList.length; i++) {
                    ids.push(popQuestionList[i].question_id)
                }
                this.loadQuestion({ ids, id: 0, qtype: 0, loadType: 'wrong' });
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //我的收藏
        async loadFavoriteList({ id, pid }) {
            let res = await global.http.post('home/queryCollectQuestionInitList', {
                course_id: id,
                paper_id: pid
            });
            if (res.errcode === 0) {
                dispatch.modal.LOAD_ANSWERSHEET({ answerSheet: res.result })
                let popQuestionList = res.result.indexList;
                // eslint-disable-next-line no-unused-vars
                let count = 0;//缓冲计数
                let ids = [];//查询的id
                // eslint-disable-next-line no-unused-vars
                let isFound = false;
                for (let i = 0; i < popQuestionList.length; i++) {
                    ids.push(popQuestionList[i].question_id)
                }
                this.loadQuestion({ ids, id: 0, qtype: 0, loadType: 'favorite' });
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //登录授权
        async getAuth(url) {
            let res = await global.http.post('getOpenid/getCode', { redirect_uri: url })
            if (res.errcode === 0) {
                let jumpUrl = res.result.url;
                console.log(jumpUrl, '<--------jumpUrl')
                window.location.href = jumpUrl
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //获取openid
        async getOpenid({ code, type, cb }, state) {
            let res = await global.http.post('getOpenid/getOpenid', { code, is_automatic_login: type })
            console.log(res, '<--------------getOpenid')
            if (res.errcode === 0) {
                dispatch.modal.SAVE_OPENID({ openid: res.result.open_id })
                Cookie.set('openid', res.result.open_id, { path: '/' })
                if (res.result.token) {
                    Cookie.set('authorization', res.result.token, { path: '/' })
                }
                if (state.modal && state.modal.isLogin) {
                    return
                }
                let userInfo = res.result;
                Cookie.set('userInfo', userInfo, { path: '/' })
                dispatch.modal.querySuccess({ payload: { userInfo: userInfo, isLogin: true } })
                cb()
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        async getNewsClassify() {
            let res = await apiNewsClassify()
            if (res.errcode === 0) {
                dispatch.modal.querySuccess({ payload: { newsClassifyList: res.result } })
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        async getNewsList({ id }) {
            let res = await apiNewsList({ kind_id: id })
            if (res.errcode === 0) {
                dispatch.modal.querySuccess({ payload: { newsList: res.result.list } })
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        setNewsCurrentId({ id, idx }) {
            dispatch.modal.querySuccess({ payload: { newsCurrentId: id, newsCurrentIdx: idx } })
        }
    })
}

//找到章节并展开或折叠
function findAndToggleFolder(chapter, id) {
    if (!chapter) {
        return;
    }
    for (let i = 0; i < chapter.length; i++) {
        if (chapter[i]) {
            if (chapter[i].course_id === id) {
                chapter[i].open = !chapter[i].open;
                break;
            }
            if (chapter[i].childrens) {
                findAndToggleFolder(chapter[i].childrens, id)
            }
        }
    }
}
